export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6712.ba0e3041.jpg";